import {
  Avatar,
  makeStyles,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import { useContext } from "react";
import { useAuth } from "../../authentication/AuthContextProvider";
import { useTranslation } from "react-i18next";
import { DataContext } from "../../context/DataContext";
import { ChevronDownRegular } from "@fluentui/react-icons";
import { BrandLogo } from "../logo/BrandLogo";
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    top: 0,
    left: 0,
    padding: "20px",
  },
  positionAbsolute: {
    position: "absolute",
  },
  menuButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
  },
  logo: {
    height: "40px",
    width: "auto",
  },
});

export const Header = (): JSX.Element => {
  const styles = useStyles();
  const dataContext = useContext(DataContext);
  const { authUser } = dataContext.state;
  const auth = useAuth();
  const { t } = useTranslation();
  const authenticatedUser = authUser && !authUser?.firstLogin;

  return (
    <div
      className={`${!authenticatedUser && styles.positionAbsolute} ${styles.container}`}
    >
      <BrandLogo />
      {authenticatedUser && (
        <div>
          <Menu>
            <MenuTrigger disableButtonEnhancement>
              <div className={styles.menuButton}>
                <Avatar name={authUser?.title ?? ""} />
                <ChevronDownRegular />
              </div>
            </MenuTrigger>
            <MenuPopover>
              <MenuList>
                <MenuItem onClick={() => auth.logout(dataContext)}>
                  {t("buttons.logout")}
                </MenuItem>
              </MenuList>
            </MenuPopover>
          </Menu>
        </div>
      )}
    </div>
  );
};
